import { useEffect, useState } from "react";
import { useSettingsController } from "../controller";
import { SettingsCard } from "./SettingsCard";
import { SettingsItem } from "./SettingsItem";

export const RentersWarehouseIntegration = () => {
  const { currentSettings, updateSettings } = useSettingsController();
  const [editMode, setEditMode] = useState(false);

  const [apiKey, setApiKey] = useState("");
  const [url, setUrl] = useState("");
  const [domain, setDomain] = useState("");
  const [clientId, setClientId] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const settings = currentSettings.rentersWarehouse;

  useEffect(() => {
    setApiKey(settings.rentersWarehouseApiKey || "");
    setUrl(settings.rentersWarehouseUrl || "");
    setDomain(settings.rentersWarehouseSalesforceDomain || "");
    setClientId(settings.rentersWarehouseSalesforceClientId || "");
    setClientSecret(settings.rentersWarehouseSalesforceClientSecret || "");
    setUsername(settings.rentersWarehouseSalesforceUsername || "");
    setPassword(settings.rentersWarehouseSalesforcePassword || "");
  }, [
    settings.rentersWarehouseApiKey,
    settings.rentersWarehouseUrl,
    settings.rentersWarehouseSalesforceDomain,
    settings.rentersWarehouseSalesforceClientId,
    settings.rentersWarehouseSalesforceClientSecret,
    settings.rentersWarehouseSalesforceUsername,
    settings.rentersWarehouseSalesforcePassword
  ]);

  return (
    <SettingsCard
      title="Renters Warehouse Integration"
      editMode={editMode}
      setEditMode={setEditMode}
      onSave={() => {
        if (
          settings.rentersWarehouseApiKey !== apiKey ||
          settings.rentersWarehouseUrl !== url ||
          settings.rentersWarehouseSalesforceDomain !== domain ||
          settings.rentersWarehouseSalesforceClientId !== clientId ||
          settings.rentersWarehouseSalesforceClientSecret !== clientSecret ||
          settings.rentersWarehouseSalesforceUsername !== username ||
          settings.rentersWarehouseSalesforcePassword !== password
        )
          updateSettings({
            rentersWarehouseApiKey: apiKey,
            rentersWarehouseUrl: url,
            rentersWarehouseSalesforceDomain: domain,
            rentersWarehouseSalesforceClientId: clientId,
            rentersWarehouseSalesforceClientSecret: clientSecret,
            rentersWarehouseSalesforceUsername: username,
            rentersWarehouseSalesforcePassword: password
          });
      }}
    >
      <SettingsItem
        title="API Key"
        value={apiKey}
        editMode={editMode}
        onChange={setApiKey}
      />

      <div className="mt-4">
        <SettingsItem
          title="URL"
          value={url}
          editMode={editMode}
          onChange={setUrl}
        />
      </div>

      <div className="mt-4">
        <SettingsItem
          title="Salesforce Domain"
          value={domain}
          editMode={editMode}
          onChange={setDomain}
        />
      </div>

      <div className="mt-4">
        <SettingsItem
          title="Salesforce Client ID"
          value={clientId}
          editMode={editMode}
          onChange={setClientId}
        />
      </div>

      <div className="mt-4">
        <SettingsItem
          title="Salesforce Client Secret"
          value={clientSecret}
          editMode={editMode}
          onChange={setClientSecret}
        />
      </div>

      <div className="mt-4">
        <SettingsItem
          title="Salesforce Username"
          value={username}
          editMode={editMode}
          onChange={setUsername}
        />
      </div>

      <div className="mt-4">
        <SettingsItem
          title="Salesforce Password"
          value={password}
          editMode={editMode}
          onChange={setPassword}
          password={true}
        />
      </div>
    </SettingsCard>
  );
};
